import { useCallback } from 'react';

import { postTipification } from '../services/tipification/tipification.service';

import { TipificationKeys } from '../constants/tipification.constant';

type TipificationEventKey =
  typeof TipificationKeys[keyof typeof TipificationKeys];

interface TrackingResult {
  success: boolean;
  eventKey: string;
}

interface UseTipificationReturn {
  trackEvent: (
    eventKey: TipificationEventKey,
    comment?: string
  ) => Promise<boolean>;
  trackEventAsync: (eventKey: TipificationEventKey, comment?: string) => void;
  getAvailableEvents: () => typeof TipificationKeys;
  events: typeof TipificationKeys;
}

export const useTipification = (): UseTipificationReturn => {
  const trackEvent = useCallback(
    async (
      eventKey: TipificationEventKey,
      comment?: string
    ): Promise<boolean> => {
      if (!Object.values(TipificationKeys).includes(eventKey)) {
        console.warn(
          `Evento no válido: ${eventKey}. Eventos disponibles:`,
          Object.keys(TipificationKeys)
        );
        return false;
      }

      try {
        await postTipification(eventKey, comment?.toString());
        return true;
      } catch (error) {
        console.error(`Error registrando evento ${eventKey}:`, error);
        return false;
      }
    },
    []
  );

  const trackEventAsync = useCallback(
    (eventKey: TipificationEventKey, comment?: string): void => {
      trackEvent(eventKey, comment);
    },
    [trackEvent]
  );

  const getAvailableEvents = useCallback((): typeof TipificationKeys => {
    return TipificationKeys;
  }, []);

  return {
    trackEvent,
    trackEventAsync,
    getAvailableEvents,
    events: TipificationKeys,
  };
};

export type { TipificationEventKey };
